import React from 'react';
import { Validations } from 'interfaces';
import { Form, InputNumber as AntdNumberInput } from 'antd';
import { FormItemLayout } from 'antd/es/form/Form';
import useFormValidation from '../../utils/useFormValidation';
import { Rule } from 'rc-field-form/lib/interface';

export const decimalInputParser = (displayValue?: string): string =>
  (displayValue ?? '').replace(',', '.').replace(/[^\w.-]+/g, '');

export interface InputNumberProps extends Validations {
  onChange?: (value: number | string | undefined | null) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'large' | 'middle' | 'small';
  value?: number;
  defaultValue?: number;
  min?: number;
  max?: number;
  maxLength?: number;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  rules?: Rule[];
  name?: (string | number)[] | string | number;
  formatter?: (
    value: any | undefined,
    info: {
      userTyping: boolean;
      input: string;
    }
  ) => string;
  parser?: (displayValue: string | undefined) => any;
  initialValue?: number;
  precision?: number;
  step?: number;
  className?: string;
  suffix?: React.ReactNode;
  controls?: boolean | { upIcon?: React.ReactNode; downIcon?: React.ReactNode };
  layout?: FormItemLayout;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  addonAfter?: React.ReactNode;
  addonBefore?: React.ReactNode;
}

export const InputNumber = ({
  onChange,
  size = 'large',
  value,
  defaultValue,
  onBlur,
  min,
  max,
  maxLength,
  disabled,
  label,
  name,
  rules,
  validations,
  formatter,
  parser,
  initialValue,
  precision,
  step,
  className,
  suffix,
  controls,
  layout,
  type,
  placeholder,
  addonAfter,
  addonBefore,
  required,
}: InputNumberProps) => {
  const { formValidations } = useFormValidation();

  return (
    <Form.Item
      label={label}
      name={name}
      rules={validations ? formValidations(validations) : rules}
      layout={layout}
      initialValue={initialValue}
      className={className}
      required={required}
    >
      <AntdNumberInput
        onChange={onChange}
        size={size}
        value={value}
        defaultValue={defaultValue}
        onBlur={onBlur}
        min={min}
        suffix={suffix}
        max={max}
        type={type}
        controls={controls}
        formatter={formatter}
        maxLength={maxLength}
        className={
          !className ? (disabled ? 'ant-input-disabled' : '') : className
        }
        disabled={disabled}
        parser={parser ?? decimalInputParser}
        precision={precision}
        step={step}
        placeholder={placeholder}
        addonAfter={addonAfter}
        addonBefore={addonBefore}
      />
    </Form.Item>
  );
};
